import * as v from 'valibot';
import { integerInRange, dateStringSchema } from '../util/valibot';
export const nexaTransmitterKindSchema = v.union([v.literal('onoff'), v.literal('dimmer')]);
export const nexaTransmitterSchema = v.object({
    id: integerInRange(0, 0xffffffff),
    kind: nexaTransmitterKindSchema,
    title: v.string(),
    comment: v.string(),
    code: integerInRange(0, 0x3ffffff),
    unit: integerInRange(0, 15),
    created: dateStringSchema,
});
export function nexaTransmitterKindLabel(kind) {
    switch (kind) {
        case 'onoff': return 'På/Av';
        case 'dimmer': return 'Dimmer';
    }
}
